/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentOrderCartItems } from '../../../../hooks/useCurrentOrderCartItems';
import usePreventNavigation from '../../../../hooks/usePreventNavigation';
import RegularProductConfig from '../regular/RegularProductConfig';
import cartUtils from '../../../../utils/cart';
import {
  isShippingRestrictedForParent,
  availableIncentiveProducts,
} from '../../helpers/internationalRestriction';

const IncentivesConfig = ({ history }) => {
  // prevent user from navigating away from this page
  usePreventNavigation(history, '/v3/incentives/config');

  const cartItems = useCurrentOrderCartItems();
  const dispatch = useDispatch();
  const {
    v3Order: { orders },
    shoot: shootState,
    parent,
    cartVoucherItems,
  } = useSelector((state) => state);
  const { incentiveProducts: rawIncentiveProducts, shoot } = shootState;
  const restricted = isShippingRestrictedForParent(shoot, parent);
  const incentiveProducts = availableIncentiveProducts(
    rawIncentiveProducts,
    restricted,
  );

  // Get voucher data for incentive calculations
  const voucherTotalCents = cartVoucherItems?.voucherSubtotalCents || 0;
  const hasVouchers = cartVoucherItems?.items?.length > 0;

  let incentivesToConfig = cartUtils.eligibleIncentivesForOrder(
    cartItems,
    incentiveProducts,
    voucherTotalCents,
    hasVouchers,
  );

  if (incentivesToConfig?.length === 0) {
    incentivesToConfig = cartUtils.eligibleIncentivesForCart(
      orders,
      incentiveProducts,
      voucherTotalCents,
    );
  }

  // if no incentives to config, push to offerings
  if (incentivesToConfig && incentivesToConfig.length === 0) {
    // history.push('/v3/offers'); // TODO: revisit -- we'll need to address usePreventNavigation is we event want to use this
    return null;
  }

  let incentiveProduct = null;

  if (incentivesToConfig && incentivesToConfig.length > 0) {
    incentiveProduct = incentivesToConfig[0];
  }

  // TODO: log error here and show generic error message
  if (!incentiveProduct) {
    <div>
      <p>There was an error</p>
      <p>Error code: E211 - no incentive product to display</p>
    </div>;
  }

  return (
    <RegularProductConfig
      product={incentiveProduct}
      incentiveProducts={incentiveProducts}
    />
  );
};

IncentivesConfig.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    block: PropTypes.func.isRequired,
  }).isRequired,
};

export default IncentivesConfig;
